export default __webpack_public_path__ + "5ca5eba2f0c9ca8759811ef83f0db2b2.jpg";